const LogoMark = ({ height = 24 }) => {
  const scale = height / 34;
  return (
    <svg
      viewBox="0 0 242 34"
      width={Math.round(242 * scale)}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Soundboard.space logo mark"
    >
      <g opacity="0.80">
        <circle cx="146" cy="17" r="17" fill="#4C4F56" />
        <rect x="146" y="0" width="96" height="34" fill="#4C4F56" />
      </g>
      <g opacity="0.75">
        <rect x="104" y="0" width="76" height="34" rx="17" ry="17" fill="#8A8278" />
      </g>
      <g opacity="0.85">
        <rect x="52" y="0" width="86" height="34" rx="17" ry="17" fill="#A89A4A" />
      </g>
      <g opacity="0.90">
        <rect x="0" y="0" width="86" height="34" rx="17" ry="17" fill="#B5636A" />
      </g>
    </svg>
  );
};

export default LogoMark;
